import React from "react";
import EMIcalculator from "../components/EMICalculator";
import SIPcalculator from "../components/SIPCalculator";
import LumpsumCalculator from "../components/LumpsumCalculator";
import RetirementPlanner from "../components/RetirementPlanner";

function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-6xl px-4 ${className}`}>{children}</div>;
}

export default function Tools() {
  return (
    <div className="min-h-screen bg-white">
      <Container className="py-10">
        <h1 className="text-3xl font-semibold tracking-tight sm:text-4xl text-slate-900">
          Tools & Calculators
        </h1>
        <p className="mt-2 max-w-2xl text-slate-600">
          Helpful calculators that build trust and increase engagement.
        </p>

        <div className="mt-8 grid gap-6 md:grid-cols-2">
          <div className="border rounded-xl p-4">
            <EMIcalculator />
          </div>
          <div className="border rounded-xl p-4">
            <SIPcalculator />
          </div>
          <div className="border rounded-xl p-4">
            <LumpsumCalculator />
          </div>
          <div className="border rounded-xl p-4">
            <RetirementPlanner />
          </div>
        </div>
      </Container>
    </div>
  );
}
